import { toast } from "sonner";

type Props = {
  heading?: string,
  type?: "failure" | "success" | "warning" | "info",
  messageList: string[] | React.ReactNode[],
};

const notify = ({
  heading = "",
  type = "warning",
  messageList,
}: Props) => {
  const message = messageList.join("\n");

  switch (type) {
    case "success":
      return toast.success(heading || message, heading ? { description: message } : undefined);
    case "failure":
      return toast.error(heading || message, heading ? { description: message } : undefined);
    case "warning":
      return toast.warning(heading || message, heading ? { description: message } : undefined);
    case "info":
      return toast.info(heading || message, heading ? { description: message } : undefined);
    default:
      return toast.warning(heading || message, heading ? { description: message } : undefined);
  }
};

export default notify;
